import { notification } from 'antd';
import * as Sentry from '@sentry/react';

export const NotificationService = {
  success: (message, config = {}) => {
    notification.success({ message, ...config });
  },

  error: (message, sentryLogError = null, config = {}) => {
    notification.error({ message, ...config });
    if (sentryLogError) {
      Sentry.captureException(sentryLogError);
    }
  },

  warn: (message, config = {}) => {
    notification.warn({ message, ...config });
  },

  info: (message, config = {}) => {
    notification.info({ message, ...config });
  }
};
